export const RemovePrefix = (name) => {
  const pattern = /^(MR\.|MISS\.|MSR\.|MS\.)\s*/;
  return name.replace(pattern, "");
};
